import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link, useParams } from 'react-router';
import { EmptyState, PageHeader } from '@/shared/ui';
import { ReviewDetail } from '@/widgets/review-detail';

/** 어드민 후기 상세(/reviews/:reviewId) — 주소 해석만 하고 내용은 위젯이 그린다. */
export const ReviewDetailPage = (): ReactElement => {
  const { reviewId } = useParams<{ reviewId: string }>();
  const parsed = normalizedUuidSchema.safeParse(reviewId);

  return (
    <>
      <PageHeader
        title="후기 상세"
        actions={
          <Link to="/reviews" className="text-sm underline underline-offset-4">
            목록으로
          </Link>
        }
      />
      {parsed.success ? (
        <ReviewDetail key={parsed.data} reviewId={parsed.data} />
      ) : (
        <EmptyState isError>올바른 후기 주소가 아닙니다.</EmptyState>
      )}
    </>
  );
};
